import { Target, Palette, LineChart, Globe, ArrowUpRight } from "lucide-react";

const BLOCKS = [
  {
    icon: Target,
    title: "Marketingové stratégie",
    desc: "Brand positioning, go-to-market plány, segmentácia, content stratégie a kompletný marketingový mix.",
    items: ["GTM", "Positioning", "Content"],
  },
  {
    icon: Palette,
    title: "Branding & Grafický dizajn",
    desc: "Vizuálna identita, logá, brand systémy, print a digitálne formáty.",
    items: ["Identity", "Logo", "Print"],
  },
  {
    icon: LineChart,
    title: "Marketing & Analytika",
    desc: "Meta Ads, Google Ads, GA4 reporting, e-mail automation a A/B testing.",
    items: ["GA4", "Meta", "Email", "ECOMAIL", "RAYNET","CRO"],
  },
  {
    icon: Globe,
    title: "Web & Technológie",
    desc: "CMS riešenia (Tilda, WordPress), no-code & AI workflows, web copy a technický SEO základ.",
    items: ["WordPress", "Tilda", "AI", "SEO"],
  },
];

export default function Competencies() {
  return (
    <section
      id="co-robim"
      data-testid="competencies-section"
      className="relative py-24 lg:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <span className="pill-tag" data-testid="competencies-pill">
              <span className="pill-dot"></span>
              02 — Čo robím
            </span>
            <h2 className="mt-6 text-4xl lg:text-6xl font-extrabold tracking-tight leading-[1.02] max-w-2xl">
              Štyri piliere, <br />
              <span className="text-[#C6F432]">pod jednou strechou.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-base lg:text-lg">
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
          {BLOCKS.map((b, idx) => (
            <article
              key={b.title}
              data-testid={`competency-card-${idx}`}
              className="group relative p-7 lg:p-9 rounded-3xl border border-white/[0.07] bg-white/[0.015] hover:bg-white/[0.04] hover:border-white/15 transition-all duration-500"
            >
              <div className="flex items-start justify-between">
                <div className="w-14 h-14 rounded-2xl bg-[#C6F432]/10 border border-[#C6F432]/25 flex items-center justify-center group-hover:bg-[#C6F432] group-hover:border-[#C6F432] transition-all">
                  <b.icon className="w-7 h-7 text-[#C6F432] group-hover:text-[#0A0A0A] transition-colors" />
                </div>
                <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-[#C6F432] group-hover:rotate-12 transition-all" />
              </div>

              <h3 className="mt-7 text-2xl lg:text-3xl font-bold tracking-tight">
                {b.title}
              </h3>
              <p className="mt-3 text-white/55 leading-relaxed">
                {b.desc}
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {b.items.map((it) => (
                  <span
                    key={it}
                    className="text-[11px] font-mono uppercase tracking-wider px-2.5 py-1 rounded-md bg-white/[0.04] border border-white/[0.07] text-white/65"
                  >
                    {it}
                  </span>
                ))}
              </div>

              <div className="absolute inset-x-7 lg:inset-x-9 bottom-7 lg:bottom-9 h-px bg-gradient-to-r from-[#C6F432]/0 via-[#C6F432]/40 to-[#C6F432]/0 opacity-0 group-hover:opacity-100 transition-opacity" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
